import { Result as _Result } from "./useSpaceConfig";

export { default, MutationType } from "./useSpaceConfig";
export { makeComponent } from "./reducer";
export type Result = _Result;
